import './App.css';

import { ConnectedRouter } from 'connected-react-router';
import * as React from 'react';
import { Provider } from 'react-redux';

import { AppBodyContainer } from './AppBody';
import { HeaderContainer } from './components';
import { PlayerContainer } from './components/Player/Player';
import history from './history';
import AudiostorePlayer from './lib/AudiostorePlayer';
import {
  newStore,
} from './store';
const store = newStore();

class App extends React.Component {

  public render() {
    return (
      <Provider store={ store }>
        <ConnectedRouter history={history}>
          <div id="app">
            <HeaderContainer />
            <AppBodyContainer />
            <PlayerContainer />
            <AudiostorePlayer />
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx